import { formatCurrency } from '../../lib/format';
import type { CoinDetailSnapshot } from '../../types/market';
import { Badge } from '../ui/Badge';
import { Panel } from '../ui/Panel';

export function MarketDriverPanel({ detail }: { detail: CoinDetailSnapshot }): React.JSX.Element {
  return (
    <Panel
      title="Observed 24-hour venue activity"
      description={detail.observedDriver}
      action={<Badge tone={detail.attributionConfidence === 'high' ? 'positive' : detail.attributionConfidence === 'medium' ? 'info' : 'warning'}>{detail.attributionConfidence} confidence</Badge>}
    >
      <div className="attribution-list">
        {detail.attribution.length === 0 ? (
          <p className="panel-description">No reliable venue activity mix is currently available.</p>
        ) : (
          detail.attribution.map((item) => (
            <div className="attribution-row" key={item.label}>
              <strong>{item.label}</strong>
              <div className="attribution-bar"><span style={{ width: `${Math.min(100, item.percentage)}%` }} /></div>
              <span className="metric-value">{item.percentage.toFixed(1)}%</span>
              <span className="panel-description">{formatCurrency(item.amount)} · {item.confidence}</span>
            </div>
          ))
        )}
        {detail.dex.identityConfidence === 'symbol-only' && (
          <div className="notice">DEX pools were found by ticker text only. Their volume is displayed separately but excluded from combined asset totals because unrelated tokens can share a symbol.</div>
        )}
        <div className="notice">{detail.observedDriverExplanation}</div>
      </div>
    </Panel>
  );
}
